export default __webpack_public_path__ + "static/media/usdt.6e262a99.png";